import { Month } from '../../view/admin/getEstimationMonths';
import Order, { ArticleOrderDraft, ItemOrderDraft } from '../Order';
import calculatePrice from '../calculatePrice';

export interface OrderDetails {
    pcs: number;
    totalPrice: number;
}

interface DetailsByType {
    checkoutDetails: OrderDetails;
    stockDetails: OrderDetails;
}

export interface OrdersDetails extends DetailsByType {
    month: Month;
    total: OrderDetails;
}

export default (order: Order, discount: number): OrdersDetails => {
    const detailsByType: DetailsByType = order.articlesOrdersDrafts.reduce(
        (result: DetailsByType, article: ArticleOrderDraft): DetailsByType => {
            return article.itemsOrdersDrafts.reduce((r: DetailsByType, item: ItemOrderDraft): DetailsByType => {
                return {
                    ...r,
                    stockDetails: {
                        pcs: r.stockDetails.pcs + item.toOrderFromStock,
                        totalPrice:
                            r.stockDetails.totalPrice +
                            calculateSum(article.wholesalePrice, article.discountCodeASet, discount, item.toOrderFromStock)
                    },
                    checkoutDetails: {
                        pcs: r.checkoutDetails.pcs + item.toOrderFromEstimation,
                        totalPrice:
                            r.checkoutDetails.totalPrice +
                            calculateSum(article.wholesalePrice, article.discountCodeASet, discount, item.toOrderFromEstimation)
                    }
                };
            }, result);
        },
        {
            checkoutDetails: {
                pcs: 0,
                totalPrice: 0
            },
            stockDetails: {
                pcs: 0,
                totalPrice: 0
            }
        }
    );

    return {
        month: order.month,
        ...detailsByType,
        total: {
            pcs: detailsByType.stockDetails.pcs + detailsByType.checkoutDetails.pcs,
            totalPrice: detailsByType.stockDetails.totalPrice + detailsByType.checkoutDetails.totalPrice
        }
    };
};

const calculateSum = (price: number, discountCodeASet: boolean, discount: number, toOrder: number): number =>
    calculatePrice(price, discount, discountCodeASet) * toOrder;



// WEBPACK FOOTER //
// ./src/domain/orders/getOrderDetails.ts